module.exports = __webpack_public_path__ + "img/filete_de_pescado.0b56bb39.jpeg";